import { Button, Center, Container, Stack, Text, ThemeIcon } from 'ui';
import { IconLoadingError } from 'ui/Icons';

import { ErrorBoundaryCardProps } from './types';

type ErrorCardProps = ErrorBoundaryCardProps;

const ErrorPage = ({
  title = 'Something went wrong while loading the page.',
  description = 'Please check your internet connection or try refreshing.',
  icon = true,
  withRetry = true,
  resetError,
}: ErrorCardProps) => {
  return (
    <Container size="lg" p="lg">
      <Center>
        <Stack gap={24} maw={400}>
          {icon && (
            <Center>
              <ThemeIcon variant="transparent" size={167}>
                <IconLoadingError size={167} />
              </ThemeIcon>
            </Center>
          )}

          <Stack ta="center" gap={8}>
            {title && (
              <Text fz="20" fw="600" c="gray.6">
                {title}
              </Text>
            )}
            {description && (
              <Text c="gray.6" fz="12">
                {description}
              </Text>
            )}
          </Stack>

          {withRetry && (
            <Button onClick={resetError} fullWidth>
              Refresh Page
            </Button>
          )}
        </Stack>
      </Center>
    </Container>
  );
};

export { ErrorPage };
